import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import './application.css'

const container = document.getElementById('app')
if (!container) {
  throw new Error('Missing #app mount point in the Rails layout')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
